
import React from 'react';
import { Users, Globe, Star } from 'lucide-react';

const GlobalDiversityInclusion = () => {
  const diversityImages = [
    {
      src: "/lovable-uploads/9e9fc432-2b80-4041-b7d9-47b6d2b10f86.png",
      alt: "Basketball trainee in gym"
    },
    {
      src: "/lovable-uploads/8cfd9bd2-148d-43f0-8b29-2a4e895bfec0.png",
      alt: "Young female basketball player"
    },
    {
      src: "/lovable-uploads/289a2f1a-6fa0-4b51-a0f4-6d642774d998.png",
      alt: "Female trainee in Panthers jersey"
    },
    {
      src: "/lovable-uploads/cea7179c-235e-4efe-80cf-e988c0cd3980.png",
      alt: "Trainee with basketball"
    },
    {
      src: "/lovable-uploads/ceed7047-0b84-4b28-bca6-4e6a34701430.png",
      alt: "Two trainees with championship trophy"
    },
    {
      src: "/lovable-uploads/4e0b8457-6740-4b12-b4e7-c5877efc18c0.png",
      alt: "Group of diverse basketball trainees"
    },
    {
      src: "/lovable-uploads/a54ceb94-7d97-4b9d-a03f-e74568ed4997.png",
      alt: "Large group training session"
    },
    {
      src: "/lovable-uploads/72c970fa-927d-40e9-8fbc-01176004f4da.png",
      alt: "Female basketball player in Lions jersey"
    }
  ];

  return (
    <section className="py-8 sm:py-12 md:py-16 bg-gradient-to-r from-primary/5 to-secondary/5">
      <div className="container mx-auto px-3 sm:px-6">
        <div className="max-w-6xl mx-auto text-center">
          {/* Header */}
          <div className="flex items-center justify-center gap-3 mb-6 sm:mb-8">
            <Globe className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-primary">
              Global Diversity & Inclusion
            </h2>
          </div>
          
          {/* WHO WE ARE Section */}
          <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-8 mb-6 sm:mb-8 border border-primary/10">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Users className="h-5 w-5 sm:h-6 sm:w-6 text-secondary" />
              <h3 className="text-xl sm:text-2xl font-bold text-secondary">WHO WE ARE</h3>
            </div>
            <p className="text-base sm:text-lg md:text-xl text-gray-700 leading-relaxed">
              We are the most culturally diverse (Player Development System) basketball training 
              organization in this region. We have an overwhelming appreciation for global diversity 
              and inclusion as seen through the eyes of our trainees.
            </p>
          </div>
          
          {/* Image Gallery */}
          <div className="mb-6 sm:mb-8">
            <h3 className="text-xl sm:text-2xl font-bold text-primary mb-4">Our Diverse Community</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
              {diversityImages.map((image, index) => (
                <div key={index} className="rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                  <img 
                    src={image.src} 
                    alt={image.alt}
                    className={`w-full h-32 sm:h-40 md:h-48 object-cover ${
                      image.src === "/lovable-uploads/72c970fa-927d-40e9-8fbc-01176004f4da.png" || 
                      image.src === "/lovable-uploads/289a2f1a-6fa0-4b51-a0f4-6d642774d998.png" ||
                      image.src === "/lovable-uploads/cea7179c-235e-4efe-80cf-e988c0cd3980.png"
                        ? "object-top" 
                        : ""
                    }`}
                  />
                </div>
              ))}
            </div>
          </div>
          
          {/* Commitment to Excellence */}
          <div className="mb-6 sm:mb-8">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Star className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
              <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-primary">
                A Commitment To Excellence
              </h3>
            </div>
          </div>
          
          {/* World Changers Section */}
          <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 md:p-8 border border-primary/10">
            <h4 className="text-lg sm:text-xl md:text-2xl font-bold text-secondary mb-4">
              My Trainees Have The Ability To Be World Changers
            </h4>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalDiversityInclusion;
